import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';

import './WorkflowHeader.scss';

@inject('stores')
@observer
class WorkflowHeader extends React.Component {
    public props: any;
    constructor(props: any) {
        super(props);
    }
    public renderWorkflowHeader() {
        if ( this.props.location.pathname.includes('test') ) {
            if ( this.props.match.params.taskId !== 'new' ) {
                return(
                    this.props.workflowHeaderItems[0].map((item: string, index: number) => {
                        // if (this.props.isInventoryReport === true) {
                            return(
                                <li className={ this.props.location.pathname.includes(item.toLowerCase().replace(/ /g, '')) ? "in-progress" : "to-do" } key={index}>
                                    <Link 
                                        className={'inner_cell'}
                                        to={ 
                                            item === 'Well Data' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/welldata/testsetup" :
                                            item === 'Hole Geometry' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/holegeometry/bitdata" :
                                            item === 'Drilling Pump' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/drillingpump" :
                                            item === 'Fluid Data' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/fluiddata/mudproperties" :
                                            item === 'Inventory' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/inventory/products" : '' 
                                        }>
                                        {item}
                                    </Link>
                                </li>
                            );
                        // } else if (item !== 'Inventory') {
                        //     return <Link 
                        //             to={ 
                        //                 item === 'Well Data' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/welldata/testsetup" :
                        //                 item === 'Hole Geometry' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/holegeometry/casingandinterval" :
                        //                 item === 'Drilling Pump' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/drillingpump" :
                        //                 item === 'Fluid Data' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/fluiddata/mudproperties" :
                        //                 item === 'Inventory' ? "/well/" + this.props.match.params.wellId + "/test/" + this.props.match.params.taskId + "/inventory/products" : '' 
                        //             } key={index}>
                        //                 <li className={ this.props.location.pathname.includes(item.toLowerCase().replace(/ /g, '')) ? "in-progress" : "to-do" }>{item}</li>
                        //             </Link>;
                        // } else {
                        //     return <li key={index} className={'another-class'}>{item}</li>;
                        // }
                    })
                );
            } else {
                return(
                    this.props.workflowHeaderItems[0].map((item: string, index: number) =>
                        <li key={index} className={index === 0 ? 'in-progress' : 'to-do'}><span className={'inner_cell'} >{item}</span></li>
                    )
                );
            }
        } else {
            if ( this.props.match.params.wellId !== 'new' ) {
                return(
                    this.props.workflowHeaderItems[0].map((item: string, index: number) => {
                        const path = "/well/"
                        + this.props.match.params.wellId
                        + "/" + item.toLowerCase().replace(/ /g, '')
                        + (item === 'Well Close' ? "/productsreview" : '');
                        const wellCloseMatch = item === 'Well Close' && 
                            this.props.match.url.includes("/well/"
                            + this.props.match.params.wellId
                            + "/" + item.toLowerCase().replace(/ /g, ''));
                        return (
                        <li className={ this.props.match.url === path || wellCloseMatch ? "in-progress" : "to-do" } key={index}>
                            <Link 
                                className={'inner_cell'}
                                to={path}
                            >
                                {item}
                            </Link>
                        </li>
                        );
                    })
                );
            } else {
                return(
                    this.props.workflowHeaderItems[0].map((item: string, index: number) =>
                        <li key={index} className={index === 0 ? 'in-progress' : 'to-do'}><span className={'inner_cell'}>{item}</span></li>
                    )
                );
            }
        }
    }

    public renderWorkflowSubHeader() {
        if ( this.props.match.params.taskId !== 'new' ) {
            return(
                this.props.workflowHeaderItems[1].map((item: string, index: number) =>
                    <li key={index} className={this.props.location.pathname.includes(item.toLowerCase().replace(/ /g, '')) ? "in-progress" : "to-do" } >
                        <Link 
                            to={this.props.location.pathname.substring(0, this.props.location.pathname.lastIndexOf('/') + 1) + item.toLowerCase().replace(/ /g, '')}
                            className={ 'inner_cell'}
                        >
                        {item}
                        </Link>
                    </li>
                )
            );
        } else {
            return (
                this.props.workflowHeaderItems[1].map((item: string, index: number) =>
                    <li key={index} className={index === 0 ? 'in-progress' : 'to-do'}><span className={'inner_cell'}>{item}</span></li>
                )
            );
        }
    }

    public render() {
        return(
            <div id="workflow-header">
                <ul className={ this.props.wellSetupComplete ? "complete workflow-header" : "workflow-header" }>
                    { this.renderWorkflowHeader() }
                </ul>
                { this.props.workflowHeaderItems[1] &&
                    <ul className="workflow-subheader">
                        { this.renderWorkflowSubHeader() }
                    </ul>
                }
            </div>
        );
    }
}

export default withRouter(WorkflowHeader);



// WEBPACK FOOTER //
// ./src/Components/Main/WorkflowHeader/WorkflowHeader.tsx